import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subject } from "rxjs/Subject";
import { ApiService } from "../../../shared/api-service/api.service";
import { AuthService } from "../../../shared/auth/auth.service";
import { Router, ActivatedRoute } from "@angular/router";
import { HelpersService } from "../../../shared/helpers/helpers.service";
import { SearchService } from "../../../shared/search/search.service";
import {
  ComponentID,
  ActionType,
  PermissionHelper,
} from "../../../shared/helpers/permissionshelper";
import { Logging } from "../../../logging";
import { HttpHeaders } from "@angular/common/http";

declare var jquery: any;
declare var $: any;
declare var App: any;
declare var FormSliderSwitcher: any;

@Component({
  selector: "app-wallets",
  templateUrl: "./wallets.component.html",
  styleUrls: [],
})
export class WalletsComponent implements OnInit {
  walletbrandlist: any[];
  bankbranches: any[];
  inputform: FormGroup;
  showErrors: Boolean = false;
  loading: boolean;
  hasError: boolean;
  errorMessage: any;
  successMessage: any;
  staffToken: any[];
  momoName: any[];

  currPage: number = 1;
  totalItems: number;
  itemsPerPage: number;
  search_term: any = "";
  searchTerm$ = new Subject<string>();
  savedwallets: any[];
  editid: number = 0;
  editedwallet: any = null;

  constructor(
    private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private searchService: SearchService,
    private componentid: ComponentID,
    private actiontype: ActionType,
    private permhelper: PermissionHelper,
    private route: ActivatedRoute
  ) {}

  activeRoute: string = "wallets";
  ngOnInit() {
    this.inputform = new FormGroup({
      brandgroup: new FormControl("", Validators.required),
      wallet: new FormControl(false, [
        Validators.required,
        Validators.pattern("[0-9]*"),
        Validators.minLength(10),
        Validators.maxLength(12),
      ]),
    });
    $(".default-select2").select2();

    //Setup the list
    this.getData(0);

    this.searchService.search(this.searchTerm$).subscribe((results) => {
      Logging.log("search triggered");
      this.search_term = results;
      this.getData(0);
    });

    //Fetch the available wallet brand groups
    this.api.get("/options/walletbrands").subscribe(
      (res_data) => {
        //  Logging.log(res_data.data);

        //Collect the services if the request was successful and there was data retured.
        if (res_data.status == "SUCCESS" && res_data.data.length > 0) {
          this.walletbrandlist = res_data.data;
          Logging.log(res_data.data);
        }
      },
      (error_message) => {
        //  this.loading = false;
        //  this.hasError = true;
        this.helpers.flashDanger(
          "An error has occured. Please refresh page or try again later"
        );
      }
    );

    // get URL parameters
    this.route.params.subscribe((params) => {
      if (params["walletid"]) {
        this.editid = params["walletid"];
        this.fetchWalletForEdit(params["walletid"]);
      }
    });

    //catch the select 2 onchange event
    var self = this;
    $("#brand").on("change", function () {
      self.setBrandName($(this).val());
    });

    // this.fetchStaffToken();
  }

  fetchStaffToken() {
    const staffBody = {
      email: "eani286@gmail.com",
      password: "Good4Redde@20",
      macaddress: "E8:2A:EA:8B:D8:88",
    };

    this.api.post("/users/adm/slogin", staffBody).subscribe(
      (res_data) => {
        // Logging.log(res_data.accessToken.token);

        //Set the token for the current staff.
        const staffToken: string = res_data.accessToken.token;

        this.auth.setStaffToken(staffToken);
        // Logging.log(staffToken);
      },
      (error_message) => {
        this.loading = false;
        this.hasError = true;
        this.errorMessage = error_message;
      }
    );

    return this.staffToken;
  }

  fetchWalletForEdit(id: number) {
    this.api
      .get("/accounts/" + this.auth.getAccountID() + "/wallets/" + id)
      .subscribe(
        (res_data) => {
          // Logging.log(res_data.data);
          this.editedwallet = res_data.data[0];
          this.inputform.controls.brandgroup.setValue(
            res_data.data[0].brandgroup
          );
          this.inputform.controls.wallet.setValue(res_data.data[0].wallet);

          $("#brand").select2("val", res_data.data[0].brandgroup);
        },
        (error_message) => {
          //  this.loading = false;
          //  this.hasError = true;
          this.helpers.flashDanger(
            "An error has occured. Please refresh page or try again later"
          );
        }
      );
  }

  setBrandName(brand: String) {
    const bdata = this.walletbrandlist.filter((f) => f == brand);
    if (bdata && bdata.length > 0) {
      this.inputform.controls.brandgroup.setValue(bdata[0]);
    }
  }

  getData(page: number) {
    this.loading = true;
    window.scrollTo(0, 0);
    //Fetch all users
    this.api
      .get(
        "/accounts/" +
          this.auth.getAccountID() +
          "/wallets" +
          "?sort=createddate,desc&search=" +
          this.search_term +
          "&page=" +
          page
      )
      .subscribe(
        (res_data) => {
          // Logging.log(res_data.data);
          this.savedwallets = res_data.data.content;
          this.totalItems = res_data.data.totalElements;
          this.itemsPerPage = res_data.data.size;
          this.currPage = res_data.data.number;
          this.loading = false;
        },
        (error_message) => {
          this.loading = false;
          //  this.hasError = true;
          //  this.errorMessage = error_message;
        }
      );
  }

  onSubmit() {
    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    if (this.inputform.valid) {
      // Logging.log(this.inputform.value);
      const regfields = this.inputform.value;

      const requestpayload = {
        accountid: this.auth.getAccountID(),
        brandgroup: regfields.brandgroup,
        wallet: regfields.wallet,
      };

      // const headers = new HttpHeaders({
      //   'Content-Type': 'application/json; charset=UTF-8',
      //   'Authorization': `Bearer ${this.fetchStaffToken()}`
      // });

      this.fetchStaffToken();

      const m_requestpayload = {
        header: this.fetchStaffToken(),
        mode: "Mobile Money",
        account: regfields.wallet,
        provider: regfields.brandgroup,
        name: "",
        amount: 1,
        network: regfields.brandgroup,
        walletnumber: regfields.wallet,
        accountnumber: regfields.wallet,
        bankcode: regfields.brandgroup,
        validate_name: "",
      };

      if (this.editid > 0) {
        requestpayload["id"] = this.editid;
        requestpayload["createdby"] = this.editedwallet.createdby;
        requestpayload["createddate"] = this.editedwallet.createddate;
      }

      //Save details the sub user
      const routeidadd: any = this.editid > 0 ? "/" + this.editid : "";
      const method: string = this.editid > 0 ? "PUT" : "POST";

      this.api
        .post(
          "/accounts/" + this.auth.getAccountID() + "/wallets/validatelist",
          m_requestpayload
        )
        .subscribe((res_data) => {
          Logging.log(res_data.data);
        });

      // console.log(`This token "${this.staffToken}" is staff token`);

      this.api
        .request(
          "/accounts/" + this.auth.getAccountID() + "/wallets" + routeidadd,
          method,
          requestpayload
        )
        .subscribe(
          (res_data) => {
            // Logging.log(res_data.data);
            this.helpers.flashSuccess("Wallet details saved successfully");

            if (method == "POST") {
              this.router.navigate([
                "/account/wallets/" + res_data.data[0].id + "/edit",
              ]);
            } else {
              this.router.navigate(["/account/wallets"]);
            }

            this.loading = false;
            this.hasError = false;
          },
          (error_message) => {
            this.loading = false;
            this.hasError = true;
            this.errorMessage = error_message;
          }
        );
    } else {
      this.loading = false;
      this.hasError = false;

      this.showErrors = true;
      // Logging.log("Has Errors", this.inputform.value);
    }

    // this.fetchMoMoName()
  }

  clearErrors() {
    this.hasError = false;
    this.errorMessage = "";
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/client/account/wallets/wallets.component.ts